import { render, staticRenderFns } from "./BizBusinessinfoForm1.vue?vue&type=template&id=75a648e5&"
import script from "./BizBusinessinfoForm1.vue?vue&type=script&lang=js&"
export * from "./BizBusinessinfoForm1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports